import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route key="/business/menus" path="business/menus" element={<AsyncPage />} />,
];
